import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ButtonGenerateCc from './PropertiesPaneButtonGenerateCc.jsx'
import ButtonGenerateRam from './PropertiesPaneButtonGenerateRam.jsx'
import Model from './ModelBd.mjs'

const PropertiesPaneBatchBd = (props) => {
    return (
        <PropertiesPane
            buttons={
                <>
                    <ButtonGenerateRam />
                    <ButtonGenerateCc />
                </>
            }

            Model={Model}
            {...props}
        />
    )
}

export default PropertiesPaneBatchBd
